const TvLivestreamBasePath = '/tv-livestreams';
export const TvLivestreamApiPath = TvLivestreamBasePath;
export const loadTvLivestreams = async axios => {
  const requestUrl = `${TvLivestreamBasePath}`;
  const {
    data
  } = await axios.get(requestUrl);
  return data.data;
};